import React, { } from 'react';
import logoSrc from '../img/logo.png';
import './Sales.css';



function BecomeAgent() {
  


  return (
    <>
   
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text" >
            <h1 className="banner-title" >join our team, drive success together</h1>
            <p className="banner-description">
              We have created a working system that allows monetizing activities where everyone is rewarded, increasing the distribution of services globally. You can help us with this system.
            </p>
            <a href="/sales-agent-formular" className="banner-button">
              Become an Agent
            </a>
          </div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Sales Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>

      {/* About Section */}
      <section className="about-section">
        {/* Section Introduction */}
        

        {/* How It Works */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>How It Works?</strong></h2>
            <p>
              After registration, you will be listed for future projects. We will contact you with project details and tasks aligned with your skills.
            </p>
          </div>
          <div className="about-image">
            <img src="/img/s1.1.png" alt="How It Works" />
          </div>
        </div>

        {/* Who Can Be Part Of? */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Who Can Be Part Of?</strong></h2>
            <p>
              Differentiate yourself by detailing the services you can support, which may include: Main, Premium, and Third-Party Services.
            </p>
          </div>
          <div className="about-image">
            <img src="/img/s1.2.png" alt="Who Can Join" />
          </div>
        </div>

        {/* Benefits */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>What Are the Benefits?</strong></h2>
            <p>
              You will be rewarded based on work intensity, not hourly rates. Work from anywhere, anytime, focusing on delivering quality products for our clients.
            </p>
          </div>
          <div className="about-image">
            <img src="/img/s1.3.png" alt="Benefits" />
          </div>
        </div>

        {/* Freelancer Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Freelancer Start Business Journey!</strong></h2>
            <p>
              The difference between being a solitary freelancer and joining us is that we provide community support, resources, and opportunities to enhance your career.
            </p>
          </div>
          <div className="about-image">
            <img src="/img/s1.4.png" alt="Freelancer Journey" />
          </div>
        </div>
      </section>
    </>
  );
}

export default BecomeAgent;